(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var tab = event.target.closest('[data-section="collection-tabs"] .new_filter a[data-tab]');
  if (!tab) return;

  var section = tab.closest('[data-section="collection-tabs"]');
  var panelId = tab.getAttribute('data-tab');
  var panel = section.querySelector('#' + panelId);
  if (!panel) return;

  event.preventDefault();

  section.querySelectorAll('.new_filter li').forEach(function (item) {
    item.classList.remove('active');
  });
  section.querySelectorAll('.new_filter a[data-tab]').forEach(function (item) {
    item.setAttribute('aria-selected', 'false');
  });
  section.querySelectorAll('.tab-contents').forEach(function (item) {
    item.classList.remove('active');
  });

  tab.closest('li').classList.add('active');
  tab.setAttribute('aria-selected', 'true');
  panel.classList.add('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lab20-promo-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const checkSales = () => {
      document.querySelectorAll('[data-tsl-sale-expiry]').forEach(element => {
        const expiry = Date.parse(element.dataset.tslSaleExpiry);
        if (!Number.isFinite(expiry) || Date.now() <= expiry) return;
        if (element.dataset.tslSaleFallbackImage) {
          const image = element.querySelector('img');
          if (image) {
            image.removeAttribute('srcset');
            image.src = element.dataset.tslSaleFallbackImage;
            image.alt = element.dataset.tslSaleFallbackAlt || '';
          }
          element.querySelectorAll('picture source').forEach(source => {
            if (element.dataset.tslSaleFallbackDesktopImage) {
              source.srcset = element.dataset.tslSaleFallbackDesktopImage;
              source.width = 2560;
              source.height = 1024;
            } else {
              source.remove();
            }
          });
          element.href = element.dataset.tslSaleFallbackLink;
          element.removeAttribute('data-tsl-sale-expiry');
        } else {
          element.hidden = true;
        }
      });
    };
    checkSales();
    document.addEventListener('DOMContentLoaded', checkSales, {once:true});
    document.addEventListener('shopify:section:load', checkSales);
    document.addEventListener('visibilitychange', checkSales);
    setInterval(checkSales, 15000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["overlay-image-and-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeMedia = (root) => {
      if (root.dataset.homeGryMediaReady === 'true') return;

      const video = root.querySelector('[data-desktop-video]');
      if (!video) return;

      root.dataset.homeGryMediaReady = 'true';

      const desktop = window.matchMedia('(min-width: 769px)');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const sources = Array.from(video.querySelectorAll('source[data-src]'));

      const detachSources = () => {
        video.pause();

        sources.forEach((source) => {
          if (!source.src) return;
          source.dataset.src = source.src;
          source.removeAttribute('src');
        });

        video.load();
      };

      const attachSources = () => {
        let changed = false;

        sources.forEach((source) => {
          if (source.src || !source.dataset.src) return;
          source.src = source.dataset.src;
          changed = true;
        });

        if (changed) video.load();
      };

      const synchronize = () => {
        if (!desktop.matches) {
          detachSources();
          return;
        }

        attachSources();

        if (reducedMotion.matches) {
          video.pause();
          return;
        }

        const playback = video.play();
        if (playback) playback.catch(() => {});
      };

      desktop.addEventListener('change', synchronize);
      reducedMotion.addEventListener('change', synchronize);
      synchronize();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-home-gry-media]').forEach(initializeMedia);
    };

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      initializeAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiper-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('.tsl-carousel-pause');
    if (!button) return;
    const swiper = button.closest('.swiper-container').swiper;
    if (!swiper || !swiper.autoplay) return;
    const paused = button.getAttribute('aria-pressed') === 'true';
    if (paused) swiper.autoplay.start(); else swiper.autoplay.stop();
    button.setAttribute('aria-pressed', String(!paused));
  });
  const respectCarouselMotion = () => {
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.home-banner--campaign-art .swiper-container').forEach(container => {
      if (!container.swiper || !container.swiper.autoplay) return;
      container.swiper.autoplay.stop();
      container.querySelector('.tsl-carousel-pause').setAttribute('aria-pressed', 'true');
    });
  };
  document.addEventListener('DOMContentLoaded', respectCarouselMotion);
  window.addEventListener('load', respectCarouselMotion);

  } catch(e) { console.error(e); }
})();
})();
